import * as React from "react";
import Box from "@mui/material/Box";
import { Formik } from "formik";
import { useEffect } from "react";
import Styles from "./Modify.module.scss";
// import { updateOrderDetails } from "../../redux/orders/actions/orders.actions";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { SelectField } from "../../components/Form/SelectField";
import { useState } from "react";
import {
  fetchPremiumList,
  updateHospital,
} from "../../redux/admin/actions/admin.actions";
import axios from "axios";

export default function ModifyForm(props) {
  const baseUrl = "https://lab.lifebank.ng/labx/api/v1/auth/user/state/Nigeria";

  const [prem, setPrem] = useState();
  const [stateOptionDropDown, setstateOptionDropDown] = useState();
  const [selectedState, setselectedState] = useState();

  const dispatch = useDispatch();

  const { premiumList } = useSelector((state) => state.adminReducer);

  let editType;

  if (window.localStorage.getItem("editType"))
    editType = window.localStorage.getItem("editType");

  useEffect(() => {
    dispatch(fetchPremiumList());
  }, [dispatch]);

  useEffect(() => {
    const fetchData = () => {
      axios.get(baseUrl).then((response) => {
        let options = response?.data?.states
          .sort((a, b) => (a?.name > b.name ? -1 : 1))
          .map((state) => ({
            label: state.name,
            value: state.name,
          }));
        setstateOptionDropDown(options);
      });
    };
    fetchData();
  }, []);
  useEffect(() => {
    let options = premiumList?.map((p) => ({
      label: p?.name,
      value: p?.id,
    }));
    setPrem(options);
  }, [premiumList]);


  return (
    <>
      <Formik
        initialValues={
          editType === "ADDRESS"
            ? {
                address: "",
                city: "",
                note: "",
                ref_id: props.ref_id,
              }
            : editType === "PHONE NUMBER"
            ? {
                ref_id: props.ref_id,
                contact_name: "",
                phone: "",
              }
            : editType === "EMAIL"
            ? {
                ref_id: props.ref_id,
                email: "",
              }
            : {
                ref_id: props.ref_id,
                oxygen_premium: "",
                blood_premium: "",
              }
        }
        validate={(values) => {
          const errors = {};
          if (!values.address && editType === "ADDRESS") {
            errors.address = "Required";
          }
          if (!values.city && editType === "ADDRESS") {
            errors.city = "Required";
          }
          if (!values.email && editType === "EMAIL") {
            errors.email = "Required";
          }
          if (!values.phone && editType === "PHONE NUMBER") {
            errors.phone = "Required";
          }
          if (!values.contact_name && editType === "PHONE NUMBER") {
            errors.contact_name = "Required";
          }
          if (!values.oxygen_premium && editType === "CLASS") {
            errors.oxygen_premium = "Required";
          }
          if (!values.blood_premium && editType === "CLASS") {
            errors.blood_premium = "Required";
          }
          return errors;
        }}
        onSubmit={(values) => {
          const findSelectedStateLabel = stateOptionDropDown.filter(
            // eslint-disable-next-line eqeqeq
            (state) => state.value == selectedState
          );

          values.editkey =
            editType === "ADDRESS"
              ? "Address"
              : editType === "PHONE NUMBER"
              ? "Contact"
              : editType === "EMAIL"
              ? "Email"
              : "Class";
          editType === "CLASS" &&
            (values.oxygen_premium = values.oxygen_premium.value);
          editType === "CLASS" &&
            (values.blood_premium = values.blood_premium.value);

          editType === "ADDRESS" &&
            (values.state = findSelectedStateLabel[0].label);

          dispatch(updateHospital(values));

          // console.log(values);
          props.onClickYes();
          // console.log(values);
        }}
      >
        {({
          handleChange,
          handleSubmit,
          isSubmitting,
          values,
          event,
          resetForm,
          setFieldValue,
          handleBlur,
          errors,
          touched,
        }) => (
          <>
            <Box
              component='form'
              sx={{
                "& .MuiTextField-root": { m: 1, minWidth: "50ch" },
              }}
              noValidate
              autoComplete='off'
            >
              {editType === "ADDRESS" && (
                <>
                  {errors.address && touched.address ? (
                    <p className='text-danger mt-1 mx-2'>{errors.address}</p>
                  ) : null}
                  <div className='d-flex flex-column mb-3'>
                    <p className={Styles.label}>Address</p>
                    <div>
                      <Form.Control
                        type='text'
                        onChange={handleChange}
                        name='address'
                        placeholder={props.address}
                      />
                    </div>
                  </div>

                  {errors.note && touched.note ? (
                    <p className='text-danger mt-1 mx-2'>{errors.note}</p>
                  ) : null}
                  <div className='d-flex flex-column mb-3'>
                    <p className={Styles.label}>Landmark</p>
                    <div>
                      <Form.Control
                        type='text'
                        onChange={handleChange}
                        name='note'
                        placeholder={props.note}
                      />
                    </div>
                  </div>

                  {errors.city && touched.city ? (
                    <p className='text-danger mt-1 mx-2'>{errors.city}</p>
                  ) : null}
                  <div className='d-flex flex-column mb-3'>
                    <p className={Styles.label}>City</p>
                    <div>
                      <Form.Control
                        type='text'
                        onChange={handleChange}
                        name='city'
                        placeholder={props.city}
                      />
                    </div>
                  </div>

                  {/* {errors.state && touched.state ? (
                    <p className="text-danger mt-1 mx-2">{errors.state}</p>
                  ) : null} */}
                  <div className='d-flex flex-column mb-3'>
                    <p className={Styles.label}>State</p>
                    <div>
                      <select
                        className={`${Styles.formInput} shadow-none form-control`}
                        placeholder='State of Origin'
                        name='state'
                        // onChange={(option) => loadStateLGAOption(option)}
                        values={values.State}
                        onChange={(e) => {
                          const selectedStateId = e.currentTarget.value;
                          setselectedState(selectedStateId);
                        }}
                        required
                      >
                        <option>Select State</option>
                        {stateOptionDropDown
                          ?.sort((a, b) => (a?.label > b?.label ? 1 : -1))
                          ?.map((stateOption) => {
                            return (
                              <option
                                value={stateOption?.value}
                                label={stateOption?.label}
                                key={stateOption?.value}
                              >
                                {stateOption?.label}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {editType === "CLASS" && (
                <>
                  {errors.oxygen_premium && touched.oxygen_premium ? (
                    <p className='text-danger mt-1 mx-2'>
                      {errors.oxygen_premium}
                    </p>
                  ) : null}
                  <div className='d-flex flex-column mb-3'>
                    <p className={Styles.label}>Oxygen</p>
                    <div className='w-100 mt-2'>
                      <SelectField
                        name='oxygen_premium'
                        options={prem}
                        onChange={setFieldValue}
                        placeholder={props.oxygen}
                        onBlur={handleBlur}
                      />
                    </div>{" "}
                  </div>

                  {errors.blood_premium && touched.blood_premium ? (
                    <p className='text-danger mt-1 mx-2'>
                      {errors.blood_premium}
                    </p>
                  ) : null}
                  <div className='d-flex flex-column mb-3'>
                    <p className={Styles.label}>Blood</p>
                    <div className='w-100 mt-2'>
                      <SelectField
                        name='blood_premium'
                        options={prem}
                        onChange={setFieldValue}
                        placeholder={props.blood}
                        onBlur={handleBlur}
                      />
                    </div>{" "}
                  </div>
                </>
              )}

              {editType === "PHONE NUMBER" && (
                <>
                  {errors.contact_name && touched.contact_name ? (
                    <p className='text-danger mt-1 mx-2'>
                      {errors.contact_name}
                    </p>
                  ) : null}
                  <div className='d-flex flex-column mb-3'>
                    <p className={Styles.label}>Contact Name</p>
                    <div>
                      <Form.Control
                        type='text'
                        onChange={handleChange}
                        name='contact_name'
                        placeholder={props.contact}
                      />
                    </div>
                  </div>

                  {errors.phone && touched.phone ? (
                    <p className='text-danger mt-1 mx-2'>{errors.phone}</p>
                  ) : null}
                  <div className='d-flex flex-column mb-3'>
                    <p className={Styles.label}>Phone Number</p>
                    <div>
                      <Form.Control
                        type='text'
                        onChange={handleChange}
                        name='phone'
                        placeholder={props.phone}
                      />
                    </div>
                  </div>
                </>
              )}

              {editType === "EMAIL" && (
                <>
                  {errors.email && touched.email ? (
                    <p className='text-danger mt-1 mx-2'>{errors.email}</p>
                  ) : null}
                  <div className='d-flex flex-column mb-3'>
                    <p className={Styles.label}>Email</p>
                    <div>
                      <Form.Control
                        type='email'
                        onChange={handleChange}
                        name='email'
                        placeholder={props.email}
                      />
                    </div>
                  </div>
                </>
              )}

              <div className='d-flex justify-content-center mt-3'>
                <button
                  type='submit'
                  className={` shadow-none ${Styles.actionBtn} ${Styles.confirm} `}
                  style={{ background: props.btnColor }}
                  onClick={() => props.onClickNo()}
                >
                  Cancel
                </button>

                <button
                  type='submit'
                  className={` shadow-none  ${Styles.actionBtn} ${Styles.reject}`}
                  style={{ background: props.btnColor }}
                  onClick={handleSubmit}
                >
                  Update
                </button>
              </div>
            </Box>
          </>
        )}
      </Formik>
    </>
  );
}
